import { render, staticRenderFns } from "./StartseiteZeiterfassung.vue?vue&type=template&id=067e19e6"
import script from "./StartseiteZeiterfassung.vue?vue&type=script&lang=js"
export * from "./StartseiteZeiterfassung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports